import { get, find } from "lodash";
import { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import useApp from "hooks/useApp";
import { useQuery, useQueryClient, useMutation } from "react-query";
import useApi from "hooks/useApi";
import { confirmDialog } from "primereact/confirmdialog";
const useEditPage = ({ props, formDefaultValues, afterSubmit }) => {
  const app = useApp();
  const api = useApi();
  const { pageid } = useParams(); // record id from url param e.g products/edit/23
  const [currentRecord, setCurrentRecord] = useState(null);
  const [formData, setFormData] = useState(formDefaultValues);
  const [pageReady, setPageReady] = useState(false);
  let recID = props.id || pageid;
  recID = recID || "";
  let urlGet = props.getApiPath + "/" + recID; // set api url e.g products/edit/23
  if(props.getApiPath === "account"){
    urlGet = props.getApiPath;
  }
  let urlPut = props.putApiPath; // set api url e.g products/edit/23
  const dependencyArr = [props.pageName, urlGet];
  if (props.updateCounter) {
    dependencyArr.push(props.updateCounter);
  }
  const { isLoading, isError, data, error } = useQuery(
    dependencyArr,
    () => fetchFormData(),
    { retry: false }
  );
  useEffect(() => {
    if (data) {
      const formValues = mapToFormData(data);
      setFormData(formValues);
      setCurrentRecord(data);
      setPageReady(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isError]);
  async function fetchFormData() {
    return api.get(urlGet).then((res) => res?.data);
  }
  async function submitFormData(formValues) {
    let postData = {};
    if (props.pageName === "assignMetric") {
      const newMetricId = get(formValues, "assigned_metric");
      formValues.metrics.push(newMetricId);
    }
    postData = normalizeFormData(formValues);
    return api.put(urlPut === "account/edit" ?  urlPut :urlPut + "/" + recID, postData).then((res) => res?.data);
  }
  const queryClient = useQueryClient();
  const mutation = useMutation(submitFormData, {
    retry: false,
    onSuccess: (data) => {
      queryClient.invalidateQueries(props.pageName);
      if (afterSubmit) {
        afterSubmit(data);
      }
    },
    onError: (error) => {
      app.showPageRequestError(error);
    },
  });
  function normalizeFormData(formValues) {
    const postData = { ...formValues };
    Object.keys(postData).forEach(function (key) {
      const fieldValue = postData[key];
      if (Array.isArray(fieldValue)) {
        // let firstItem = fieldValue[0];                     //commented because it convert permission array in role into strings
        // if (firstItem && typeof firstItem == "string") {
        //   postData[key] = fieldValue.toString();
        // } else {
        //   postData[key] = fieldValue;
        // }

        postData[key] = fieldValue;
      } else if (fieldValue instanceof Date) {
        postData[key] = fieldValue.toISOString().slice(0, 19).replace("T", " ");
      } else if (fieldValue === "") {
        postData[key] = null;
      }
    });
    return postData;
  }
  function mapToFormData(apiData) {
    const formValues = { ...apiData };
    Object.keys(formValues).forEach(function (key) {
      const fieldValue = formValues[key];

      const fieldDefaultValue = formDefaultValues[key];
      if (Array.isArray(fieldDefaultValue)) {
        // if (fieldValue) {
        //   formValues[key] = fieldValue.toString().split(",");
        //   formValues[key] = fieldValue;
        // } else {
        //   formValues[key] = fieldDefaultValue;
        // }
        // formValues[key] = fieldDefaultValue;
      } else if (fieldDefaultValue instanceof Date && fieldValue) {
        formValues[key] = new Date(fieldValue);
      }
    });
    return formValues;
  }
  function handleSubmit(e, formik) {
    if (!formik.isValid) {
      app.flashMsg(props.formValidationError, props.formValidationMsg, "error");
    }
  }
  function submitForm(validatedFormData) {
    let confirmMsg = props.msgBeforeSave;
    if (confirmMsg) {
      confirmDialog({
        header: props.msgTitle,
        message: confirmMsg,
        icon: "pi pi-save",
        accept: async () => {
          mutation.mutate(validatedFormData);
        },
        reject: () => {
          //callback to execute when user rejects the action
        },
      });
    } else {
      mutation.mutate(validatedFormData);
    }
  }
  function inputClassName(hasError, className = "w-full") {
    if (hasError) {
      return `${className} p-invalid`;
    }
    return className;
  }
  const pageData = {
    currentRecord,
    formData,
    inputClassName,
    setFormData,
    handleSubmit,
    submitForm,
    setCurrentRecord,
    pageReady,
    saving: mutation.isLoading,
    loading: isLoading,
    apiRequestError: error,
  };
  return useMemo(
    () => pageData,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [formData, currentRecord, pageReady, mutation.isLoading, isLoading, error]
  );
};
export default useEditPage;
